import { createFileRoute } from '@tanstack/react-router';
import { DesktopDocuments } from '@/features/warehouse/DesktopDocumenti';

/** Le registrazioni col loro numero, e l'annullo. Da tavolo: annullare è un gesto da guardare. */
export const Route = createFileRoute('/_app/warehouse/documents')({ component: DesktopDocuments });
